var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoonIconOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/moon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/moon_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "moon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.02384 12.8901C3.3398 17.2665 7.1752 20.8271 11.7654 21.0225C15.004 21.1585 17.9003 19.6969 19.638 17.3939C20.3577 16.4507 19.9716 15.8218 18.7692 16.0343C18.1811 16.1363 17.5755 16.1788 16.9436 16.1533C12.6518 15.9833 9.14117 12.5077 9.12361 8.40325C9.11484 7.29853 9.35181 6.2533 9.78186 5.30154C10.2558 4.24781 9.68532 3.74644 8.58824 4.19682C5.11268 5.61596 2.73421 9.00659 3.02384 12.8901Z",
    stroke: "#707170",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonIconOutline);
export default __webpack_public_path__ + "static/media/moon-icon-outline.0c88b169.svg";
export { ForwardRef as ReactComponent };